// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Dashboard_tabs__-rHDl","filters":"Dashboard_filters__1ctoT","suffixField":"Dashboard_suffixField__3dly8"};